<template>
    <div class="homepage-form placeholder placeholder-cover">
        <slot />
        <div class="homepage-form-text">
            <p
                v-bastards
                class="fs-16"
                v-text="text"
            />
        </div>

        <footer class="homepage-form-footer">
            <p
                v-bastards
                class="fs-15 text-color-contrast"
                v-text="footerText"
            />
        </footer>
    </div>
</template>

<script>
export default {
    props: {
        footerText: {
            type: String,
            required: false,
            default: ''
        },
        text: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss">
.homepage-form {
    padding: 93px 61px;

    &-footer {
        position: absolute;
        top: 654px;
    }

    &-text {
        color: $color-default;
        max-width: 300px;
        margin-top: 21px;
    }

    @media (max-width: $screen-laptop-large) {
        padding: 93px 21px;
    }

    @media (max-width: $screen-laptop) {
        padding: 0 61px 93px;

        &-footer {
            top: 498px;

            .text-color-contrast {
                color: $color-default;
            }
        }

        .panelbox {
            &-body {
                height: 389px;
            }
        }
    }

    @media (max-width: $screen-mobile-landscape) {
        position: static;
        padding: 0 15px 52px;

        &-footer {
            position: static;
            margin: 26px auto 0;
            width: 100%;
            max-width: 430px;
        }

        .panelbox {
            display: block;
            margin: 0 auto;

            &-body {
                height: auto;
                padding: 22px 20px 30px;
            }

            &-header {
                header {
                    font-size: 1.6rem;
                    line-height: 2.1rem;
                }
            }
        }
    }
}
</style>
